import { Formik } from "formik";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { defaultColors, styled } from "../../../stitches.config";
import { withThemeContext } from "../../components/StitchesThemeProvider";
import checkIcon from "../../../../src/assets/img/white_check.svg";
import { bodyLargeStrong } from "../../commonStyles/Fonts";

interface Props {
  colorMode?: string;
  article: any;
}

const defaultAmounts = [
  {
    amountText: "100 zł",
    amountValue: "100",
  },
  {
    amountText: "50 zł",
    amountValue: "50",
  },
  {
    amountText: "10 zł",
    amountValue: "10",
  },
  {
    amountText: "5 zł",
    amountValue: "5",
  },
  {
    amountText: "Inne",
    amountValue: "0",
  },
];

const CollectionTileFormBasic: React.FC<Props> = ({ colorMode, article }) => {

  const [selectedAmountText, setSelectedAmountText] = React.useState<string>(
    defaultAmounts[3].amountText
  );

  const [selectedNumber, setSelectedNumber] = React.useState<string>("5");

  const isDarkMode = colorMode === "dark";
  const isOtherValue = selectedAmountText === "Inne";

  const location = useLocation();
  const navigate = useNavigate();

  const onWrapperClick = () => {
    navigate(
      `${location.pathname}?modal-type=PAYMENT&payment-type=BRID&payment-brid-id=${article.articleID}&payment-value=${selectedNumber}&payment-status=pending`
    );
  };

  return (
    <Wrapper>

      <TextColumn>
        <AmountWrapper>
          {defaultAmounts.map(({ amountText, amountValue }, index) => {
            return (
              <AmountButton
                key={index}
                type="button"
                isDarkMode={isDarkMode}
                selected={selectedAmountText === amountText}
                onClick={() => {
                  setSelectedAmountText(amountText);
                  setSelectedNumber(amountValue);
                }}
              >
                {amountText}
              </AmountButton>
            );
          })}
        </AmountWrapper>
      </TextColumn>

      {isOtherValue && (
        <>
          <p className={bodyLargeStrong()}>Podaj kwotę</p>
          <Input
            type="number"
            name="amount"
            onChange={event => setSelectedNumber(event.target.value)}
            isDarkMode={isDarkMode}
          />
        </>
      )}

      <ModalButton onClick={onWrapperClick}>
        Wesprzyj projekt
      </ModalButton>
    </Wrapper >
  );
};

export default withThemeContext(CollectionTileFormBasic);

const Wrapper = styled("div", {
  marginTop: "24px",
  "@bp4": {
    marginTop: "48px",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
});

const TextColumn = styled("div", {
  h3: {
    margin: 0,
  },
  p: {
    fontWeight: "400",
    marginBottom: "32px",
    marginTop: "16px",
    maxWidth: "454px",
  },
});

const AmountWrapper = styled("div", {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  "@bp4": {
    gap: "10px",
  },
});

const AmountButton = styled("button", {
  fontSize: 16,
  whiteSpace: "nowrap",
  lineHeight: "24px",
  letterSpacing: "0px",
  fontWeight: "600",
  padding: "12px 0px",
  width: "67px",
  border: "2px solid rgba(0, 0, 0, 0.05)",
  color: "$grayscale0",
  background: "$grayscale100",
  "bp4": {
    width: "82px",
  },
  variants: {
    selected: {
      true: {
        border: "2px solid #459B2B !important",
        backgroundColor: "rgba(69, 155, 43, 0.1)",
        position: "relative",
        color: "$grayscale0Fixed",
        "&:after": {
          content: `url("${checkIcon}")`,
          position: "absolute",
          width: "16px",
          height: "16px",
          top: "-2px",
          right: "-2px",
          background: "#459B2B",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
      },
    },
    isDarkMode: {
      true: {
        borderColor: "rgba(0, 0, 0, 0.05)",
      },
      false: {
        borderColor: "rgba(255, 255, 255, 0.05)",
      },
    },
  },
});

const ModalButton = styled("div", {
  background: defaultColors.natematPrimary,
  color: "$grayscale0Fixed",
  textAlign: "center",
  border: "none",
  width: "100%",
  padding: "12px 0",
  marginTop: "16px",
  cursor: "pointer",
});


const Input = styled("input", {
  border: "2px solid rgba(0, 0, 0, 0.15)",
  background: "none",
  fontWeight: 400,
  fontSize: "16px",
  padding: "12px 14px",
  color: "$grayscale0Fixed",
  width: "100%",
  "&:focus-visible": {
    outline: "1px solid $grayscale10",
    color: "$grayscale0Fixed",
  },
  variants: {
    isDarkMode: {
      true: {
        borderColor: "rgba(0, 0, 0, 0.15)",
      },
      false: {
        borderColor: "rgba(255, 255, 255, 0.05)",
      },
    },
  },
});